import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { HERO_IMAGE, BRAND } from "../../data/content";

export default function Hero() {
  return (
    <section
      data-testid="hero-section"
      className="ground-paper pt-[104px] pb-16 md:pt-[132px] md:pb-24 lg:pt-[152px] lg:pb-28"
    >
      <div className="wrap grid lg:grid-cols-12 gap-x-10 gap-y-14 items-start">
        {/* Left — copy */}
        <div className="lg:col-span-7">
          <p className="stamp" style={{ fontSize: 12 }} data-testid="hero-kicker">
            Your new age cap-dev partner
          </p>

          <motion.h1
            initial={{ opacity: 0, y: 12 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.75, delay: 0.05, ease: [0.22, 1, 0.36, 1] }}
            className="h-hero mt-6"
            style={{ fontSize: "clamp(44px, 6.5vw, 88px)", lineHeight: 1.02 }}
            data-testid="hero-headline"
          >
            Every organisation can buy the same tools. What differs is <span className="claim">how well people think, communicate and lead</span> around them.
          </motion.h1>

          <motion.p
            initial={{ opacity: 0, y: 10 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.75, delay: 0.15 }}
            className="font-body-serif measure mt-8 text-[#0E1330]"
            style={{ fontSize: "clamp(17px, 1.4vw, 19px)", lineHeight: 1.65 }}
            data-testid="hero-sub"
          >
            Articulex is your research-led capability development partner. We design programmes around your business challenges, strengthen the thinking behind workplace behaviour, and track how people apply what they learn.
          </motion.p>

          <motion.div
            initial={{ opacity: 0, y: 10 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.75, delay: 0.25 }}
            className="flex flex-wrap gap-3 mt-10"
          >
            <Link to="/contact" data-testid="hero-cta-primary" className="btn-ink">
              Start a discovery conversation <ArrowUpRight size={16} />
            </Link>
            <Link to="/programs" data-testid="hero-cta-secondary" className="btn-outline">
              Explore capabilities
            </Link>
          </motion.div>

          <p className="stamp-dim mt-8" style={{ fontSize: 12 }} data-testid="hero-endorsement">
            Communication · Leadership · AI readiness · Workflow automation
          </p>
        </div>

        {/* Right — photograph with restrained editorial caption */}
        <div className="lg:col-span-5">
          <motion.figure
            initial={{ opacity: 0, y: 14 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.85, delay: 0.2, ease: [0.22, 1, 0.36, 1] }}
            className="relative"
          >
            <div className="frame aspect-[4/5] w-full max-w-[520px] lg:ml-auto">
              <img
                src={HERO_IMAGE}
                alt="Jasmeen Kaur facilitating a capability session"
                className="w-full h-full object-cover"
                loading="eager"
              />
            </div>
            <figcaption className="mt-4 max-w-[520px] lg:ml-auto">
              <span className="stamp" style={{ fontSize: 11 }}>
                Fig. 01 — Jasmeen Kaur facilitating a live capability session.
              </span>
            </figcaption>
          </motion.figure>
        </div>
      </div>
    </section>
  );
}
